import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { LinkButton } from 'ui-components/common/LinkButton';
import { SignLinkButton } from 'ui-components/common/SignLinkButton';
import { CertificateLinkButton } from 'ui-components/common/CertificateLinkButton';
import { HomeLinkButton } from 'ui-components/common/HomeLinkButton';
import { ViewPortMinHeight } from 'ui-components/layout/styles';

export const BlockAccessContainer = styled.div(
  ({ minHeight }: { minHeight?: number }) => css`
    width: 100%;
    ${ViewPortMinHeight(minHeight)};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0;
    font-family: Pretendard, normal, serif;
  `,
);

export const BlockAccessIcon = styled.div`
  margin-bottom: 16px;
  line-height: 0;

  svg {
    display: block;
  }
`;

export const BlockAccessTitle = styled.div`
  font-weight: ${FontWeight.Bold};
  ${Typography.XSmall};
`;

export const BlockAccessParagraph = styled.div`
  color: ${Color.Gray600};
  font-weight: ${FontWeight.Regular};
  white-space: pre-wrap;
  margin-top: 4px;
  text-align: center;
  ${Typography.XXSmall};
`;

export const BlockAccessLinkButton = styled(LinkButton)`
  display: inline-block;

  margin-top: 24px;

  > button {
    width: 100%;
  }
`;

export const BlockAccessHomeLinkButton = styled(HomeLinkButton)`
  display: inline-block;

  margin-top: 24px;

  > button {
    width: 100%;
  }
`;

export const BlockAccessSignLinkButton = styled(SignLinkButton)`
  display: inline-block;

  margin-top: 16px;

  > button {
    width: 100%;
  }
`;

export const BlockAccessCertificateLinkButton = styled(CertificateLinkButton)`
  display: inline-block;

  margin-top: 16px;

  > button {
    width: 100%;
  }
`;
